import { OrderDetails } from "../shared/types/dashboard";

export const getRecentOrders = (orders: OrderDetails[]) =>
  [...orders]
    .sort((a, b) => {
      const dateA = new Date(a.Orderdate || 0).getTime();
      const dateB = new Date(b.Orderdate || 0).getTime();
      return dateB - dateA;
    })
    .slice(0, 10);
